"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Notification Service
 * User notification api documentation
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailFromTargeterSendDtoToJSON = exports.EmailFromTargeterSendDtoFromJSONTyped = exports.EmailFromTargeterSendDtoFromJSON = exports.EmailFromTargeterSendDtoEmailCategoryEnum = exports.EmailFromTargeterSendDtoTypeEnum = void 0;
const runtime_1 = require("../runtime");
const EmailFromTargeterAudienceDto_1 = require("./EmailFromTargeterAudienceDto");
const EmailFromTargeterEmailNameDto_1 = require("./EmailFromTargeterEmailNameDto");
const EmailFromTargeterSignatureDto_1 = require("./EmailFromTargeterSignatureDto");
/**
* @export
* @enum {string}
*/
var EmailFromTargeterSendDtoTypeEnum;
(function (EmailFromTargeterSendDtoTypeEnum) {
    EmailFromTargeterSendDtoTypeEnum["CustomTemplated"] = "custom-templated";
    EmailFromTargeterSendDtoTypeEnum["CustomPlain"] = "custom-plain";
    EmailFromTargeterSendDtoTypeEnum["PlainReachout"] = "plain-reachout";
    EmailFromTargeterSendDtoTypeEnum["RichReachout"] = "rich-reachout";
    EmailFromTargeterSendDtoTypeEnum["RichReachoutV2"] = "rich-reachout-v2";
})(EmailFromTargeterSendDtoTypeEnum = exports.EmailFromTargeterSendDtoTypeEnum || (exports.EmailFromTargeterSendDtoTypeEnum = {})); /**
* @export
* @enum {string}
*/
var EmailFromTargeterSendDtoEmailCategoryEnum;
(function (EmailFromTargeterSendDtoEmailCategoryEnum) {
    EmailFromTargeterSendDtoEmailCategoryEnum["MissionNotification"] = "MissionNotification";
    EmailFromTargeterSendDtoEmailCategoryEnum["AvailabilityReminder"] = "AvailabilityReminder";
    EmailFromTargeterSendDtoEmailCategoryEnum["Community"] = "Community";
    EmailFromTargeterSendDtoEmailCategoryEnum["CompanyMarketing"] = "CompanyMarketing";
    EmailFromTargeterSendDtoEmailCategoryEnum["Referrals"] = "Referrals";
    EmailFromTargeterSendDtoEmailCategoryEnum["AutomatedRecommendedMissions"] = "AutomatedRecommendedMissions";
})(EmailFromTargeterSendDtoEmailCategoryEnum = exports.EmailFromTargeterSendDtoEmailCategoryEnum || (exports.EmailFromTargeterSendDtoEmailCategoryEnum = {}));
function EmailFromTargeterSendDtoFromJSON(json) {
    return EmailFromTargeterSendDtoFromJSONTyped(json, false);
}
exports.EmailFromTargeterSendDtoFromJSON = EmailFromTargeterSendDtoFromJSON;
function EmailFromTargeterSendDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
        'from': (0, EmailFromTargeterEmailNameDto_1.EmailFromTargeterEmailNameDtoFromJSON)(json['from']),
        'replyTo': json['replyTo'],
        'subject': json['subject'],
        'audiences': (json['audiences'].map(EmailFromTargeterAudienceDto_1.EmailFromTargeterAudienceDtoFromJSON)),
        'templateData': json['templateData'],
        'missionId': !(0, runtime_1.exists)(json, 'missionId') ? undefined : json['missionId'],
        'emailCategory': json['emailCategory'],
        'videoURL': !(0, runtime_1.exists)(json, 'videoURL') ? undefined : json['videoURL'],
        'cc': !(0, runtime_1.exists)(json, 'cc') ? undefined : (json['cc'].map(EmailFromTargeterEmailNameDto_1.EmailFromTargeterEmailNameDtoFromJSON)),
        'bcc': !(0, runtime_1.exists)(json, 'bcc') ? undefined : (json['bcc'].map(EmailFromTargeterEmailNameDto_1.EmailFromTargeterEmailNameDtoFromJSON)),
        'signature': !(0, runtime_1.exists)(json, 'signature') ? undefined : (0, EmailFromTargeterSignatureDto_1.EmailFromTargeterSignatureDtoFromJSON)(json['signature']),
    };
}
exports.EmailFromTargeterSendDtoFromJSONTyped = EmailFromTargeterSendDtoFromJSONTyped;
function EmailFromTargeterSendDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'from': (0, EmailFromTargeterEmailNameDto_1.EmailFromTargeterEmailNameDtoToJSON)(value.from),
        'replyTo': value.replyTo,
        'subject': value.subject,
        'audiences': (value.audiences.map(EmailFromTargeterAudienceDto_1.EmailFromTargeterAudienceDtoToJSON)),
        'templateData': value.templateData,
        'missionId': value.missionId,
        'emailCategory': value.emailCategory,
        'videoURL': value.videoURL,
        'cc': value.cc === undefined ? undefined : (value.cc.map(EmailFromTargeterEmailNameDto_1.EmailFromTargeterEmailNameDtoToJSON)),
        'bcc': value.bcc === undefined ? undefined : (value.bcc.map(EmailFromTargeterEmailNameDto_1.EmailFromTargeterEmailNameDtoToJSON)),
        'signature': (0, EmailFromTargeterSignatureDto_1.EmailFromTargeterSignatureDtoToJSON)(value.signature),
    };
}
exports.EmailFromTargeterSendDtoToJSON = EmailFromTargeterSendDtoToJSON;
